import LocalStorageHelper from './LocalStorageHelper';

class SentryHelper {
  setSentryTags() {
    const personalInfo = LocalStorageHelper.getPersonalInfo();
    Sentry.setUser({
      id: personalInfo?.account?.customerNumber || -1,
      username: personalInfo?.account?.customerNumber?.toString() || `-1`,
    });
    Sentry.setTag(`authenticated`, `true`); // Sentry decides to parse a bool string to bool while a bool is parsed to a string
    Sentry.setTag(`role`, personalInfo?.isPartner ? `partner` : `customer`);
  }
}

export default new SentryHelper();
